module.exports = __webpack_public_path__ + "static/media/R-PANELv6.5-RC1/PlayIconDisabled.23dbf2a9.svg";